import { render, staticRenderFns } from "./RoutineTrends.vue?vue&type=template&id=92ba49fa"
import script from "./RoutineTrends.vue?vue&type=script&lang=js"
export * from "./RoutineTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports